import GridInfo from './GridInfo';

export default GridInfo;
